(function() {
  function skcInitPrintButton() {
    var buttons = document.querySelectorAll('[id^="skc-print-btn-"]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function() {
        var title = '';
        var titleEl = document.querySelector('.product__title');
        if (titleEl) title = titleEl.innerText.trim();
        if (!title) title = document.title;

        var description = '';
var descEl = document.querySelector('.product__description.rte');
if (descEl) description = descEl.innerHTML;

// Also grab accordion bullet points
var accordionEls = document.querySelectorAll('.accordion__content.rte');
for (var a = 0; a < accordionEls.length; a++) {
  var accContent = accordionEls[a].innerHTML.trim();
  if (accContent.length > 20) {
    description += '<div style="margin-top:8px;">' + accContent + '</div>';
  }
}


        var imgSrc = '';
        var imgEl = document.querySelector('.product__media-wrapper img');
        if (!imgEl) imgEl = document.querySelector('.product-single__photo img');
        if (imgEl) imgSrc = imgEl.getAttribute('data-src') || imgEl.src;

        var logoSrc = 'https://cdn.shopify.com/s/files/1/1164/3390/files/SK_Logo.jpg?v=1717611190';

        var css = '* { margin: 0; padding: 0; box-sizing: border-box; }' +
          'body { font-family: Arial, sans-serif; font-size: 11px; color: #333; padding: 15px; background: white; }' +
          '.print-header { display: flex; align-items: center; border-bottom: 2px solid #003087; padding-bottom: 8px; margin-bottom: 12px; }' +
          '.print-header img.logo { height: 55px; width: auto; }' +
          'h1 { color: #003087; font-size: 16px; margin-bottom: 10px; }' +
          '.product-body { display: flex; gap: 15px; margin-bottom: 15px; }' +
          '.product-image { flex: 0 0 220px; }' +
          '.product-image img { width: 100%; height: auto; border: 1px solid #ddd; }' +
          '.product-info { flex: 1; font-size: 11px; line-height: 1.5; }' +
          '.product-info p, .product-info li { font-size: 11px; margin-bottom: 4px; }' +
          '.product-info ul { padding-left: 15px; }' +
          'table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 10px; }' +
          'th { background-color: #003087; color: white; padding: 5px 8px; text-align: left; }' +
          'td { padding: 4px 8px; border-bottom: 1px solid #ddd; }' +
          'tr:nth-child(even) td { background-color: #f5f5f5; }' +
          '.prop65 { font-size: 9px; color: #666; margin-top: 10px; border-top: 1px solid #ddd; padding-top: 6px; }' +
          '@page { margin: 1cm; size: letter portrait; }';

       function buildAndPrint(variantRows) {
  var tableHTML = '';
  if (variantRows) {
    tableHTML = '<table><thead><tr><th>Reorder#</th><th>Description</th><th>Unit</th></tr></thead><tbody>'
     + variantRows + '</tbody></table>';
  }
  var imgHTML = imgSrc ? '<img src="' + imgSrc + '" alt="' + title + '">' : '';
  var toolbar = '<div class="print-toolbar"><button onclick="window.print()">' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<polyline points="6 9 6 2 18 2 18 9"></polyline>' +
    '<path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>' +
    '<rect x="6" y="14" width="12" height="8"></rect>' +
    '</svg> Print</button></div>';
  var body = toolbar +
    '<div class="print-header"><img class="logo" src="' + logoSrc + '" alt="Skil-Care Corporation"></div>' +
    '<h1>' + title + '</h1>' +
    '<div class="product-body">' +
    '<div class="product-image">' + imgHTML + '</div>' +
    '<div class="product-info">' + description + '</div>' +
    '</div>' +
    tableHTML +
    '<div class="prop65">California residents: Proposition 65 WARNING</div>';
  var printCSS = css +
    '.print-toolbar { text-align: right; margin-bottom: 10px; }' +
    '.print-toolbar button { background: #003087; color: white; border: none; padding: 8px 16px; font-size: 12px; cursor: pointer; border-radius: 4px; display: inline-flex; align-items: center; gap: 6px; }' +
    '.print-toolbar button svg { width: 16px; height: 16px; vertical-align: middle; }' +
    '@media print { .print-toolbar { display: none; } }';
  var html = '<!DOCTYPE html><html><head><meta charset="utf-8"><title>' + title + ' - Skil-Care Corporation</title><style>' + printCSS + '</style></head><body>' + body + '</body></html>';
  var pw = window.open('', '_blank', 'width=850,height=1100');
  pw.document.write(html);
  pw.document.close();
  pw.focus();
}


        var handle = '';
        var canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) {
          var parts = canonical.href.split('/products/');
          if (parts[1]) handle = parts[1].split('?')[0].split('/')[0];
        }

        if (handle) {
          fetch('/products/' + handle + '.js')
            .then(function(r) { return r.json(); })
            .then(function(product) {
              var variantRows = '';
              var variants = product.variants || [];
              for (var j = 0; j < variants.length; j++) {
                var v = variants[j];
                var desc = v.title !== 'Default Title' ? title + ' - ' + v.title : title;
                var uom = (window.skcVariantUOM && window.skcVariantUOM[v.id]) ? window.skcVariantUOM[v.id] : 'EA';
variantRows += '<tr><td>' + (v.sku || '') + '</td><td>' + desc + '</td><td>' + uom + '</td></tr>';


              }
              buildAndPrint(variantRows);
            })
            .catch(function() { buildAndPrint(''); });
        } else {
          buildAndPrint('');
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', skcInitPrintButton);
  } else {
    skcInitPrintButton();
  }
})();
